// 9fbef606107a605d69c0edbcd8029e5d
import { fromJS } from 'immutable';
import { DEFAULT_REDUCER_KEY, setCacheTTL } from '@tcp/core/src/utils/cache.util';
import constants from '../OrdersTile.constants';

const initialState = fromJS({
  [DEFAULT_REDUCER_KEY]: null,
  ordersByShipment: null,
  isFetching: false,
});

const OrdersTileReducer = (state = initialState, action) => {
  switch (action.type) {
    case constants.SHOW_LOADER:
      return state.set('isFetching', true);
    case constants.HIDE_LOADER:
      return state.set('isFetching', false);
    case constants.SET_ORDERS_LIST_BY_SHIPMENT:
      return state
        .set('ordersByShipment', action.payload.orders)
        .set(DEFAULT_REDUCER_KEY, setCacheTTL(action.payload.cacheTTL))
        .set('isFetching', false);
    case constants.CLEAR_ORDERS_LIST_BY_SHIPMENT:
      return state.set(DEFAULT_REDUCER_KEY, null);
    default:
      if (state instanceof Object) {
        return fromJS(state);
      }
      return state;
  }
};

export default OrdersTileReducer;
